import React from 'react';
import { useQuery } from '@apollo/client';
import { SalvageApprovalForm } from '../../../components/AssetRelocationForms/SalvageApprovalForm';
import { ErrorMessage } from '../../../components/ErrorMessage';
import { Loader } from '../../../components/Loader';
import Navbar from '../../../components/Navbar';
import { GET_SALVAGE_BY_ID } from './api';

export const EditSalvagePage = (props: any) => {
  const { loading, error, data } = useQuery(GET_SALVAGE_BY_ID, {
    variables: {
      id: parseInt(props.match.params.salvageId),
    },
  });
  if (loading) {
    return (
      <div>
        <Navbar />
        <Loader />
      </div>
    );
  }
  if (error) {
    return (
      <div>
        <Navbar />
        <ErrorMessage title='Salvage ID not available: EditSalvagePage/index' />
      </div>
    );
  }
  return (
    <div>
      <Navbar />
      <div className='m-4'>
        <SalvageApprovalForm queryData={data.getSalvageById} />
      </div>
    </div>
    // <>
    // </>
  );
};
